export interface Account {
  id: string;
  code: string;
  name: string;
  type: 'asset' | 'liability' | 'equity' | 'income' | 'expense';
  system_role: string | null;
  default_tax_code: string | null;
  archived: boolean;
}

export interface TaxCode {
  id: string;
  code: string;
  name: string;
  kind: string;
  rate_bp: number;
}

export interface TrackingDimension {
  id: string;
  position: number;
  name: string;
  required_on_pl: boolean;
  values: { id: string; name: string }[];
}

export interface JournalLine {
  lineNo: number;
  accountId: string;
  amount: string;
  currency: string;
  taxCode: string | null;
  gstOfLineNo: number | null;
  tracking1: string | null;
  description: string | null;
}

export interface Journal {
  id: string;
  number: number | null;
  date: string;
  status: 'draft' | 'posted';
  memo: string | null;
  reverses_journal_id: string | null;
  reversed_by: string | null;
  lines: JournalLine[];
}

export const TYPE_LABELS: Record<Account['type'], string> = {
  asset: 'Assets',
  liability: 'Liabilities',
  equity: 'Equity',
  income: 'Income',
  expense: 'Expenses',
};

export const today = () => new Date().toISOString().slice(0, 10);
